<template>
  <div>
    <v-data-table
      fixed-header
      :headers="headers"
      :items="uploadResultItems"
      :items-per-page="-1"
      :footer-props="{
        'items-per-page-options':[15, 30, 50, 100, -1]
      }"
      :height="height"
      v-resize="onWindowResize"
    >
      <template v-slot:item.action="{item}">
        <v-btn x-small icon color="warning" fab depressed @click="showEditDialog(item)" v-tooltip.top="'Edit Row'">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </template>
      
    </v-data-table>

    <v-dialog v-model="invoiceItemsDialogVisibility" scrollable :max-width="400">
        <v-card>
          <v-toolbar flat color="cardHeaderTheme">
              <v-toolbar-title>Edit Invoice Items</v-toolbar-title>
          </v-toolbar>
          <v-divider></v-divider>
          <v-card-text class="mt-2">
              <v-text-field v-if="editInvoiceItem.itemNumber" v-model="editInvoiceItem.itemNumber" label="Item Number"></v-text-field>
              <v-text-field v-if="editInvoiceItem.orderedQty" v-model="editInvoiceItem.orderedQty" label="Ordered Qty"></v-text-field>
              <v-text-field v-if="editInvoiceItem.shippedQty" v-model="editInvoiceItem.shippedQty" label="Shipped Qty"></v-text-field>
              <v-text-field v-if="editInvoiceItem.itemCost" v-model="editInvoiceItem.itemCost" label="Item Cost"></v-text-field>
              <v-text-field v-if="editInvoiceItem.discountedPercentage" v-model="editInvoiceItem.discountedPercentage" label="Disc. Percentage"></v-text-field>
              <v-text-field v-if="editInvoiceItem.discountedCost" v-model="editInvoiceItem.discountedCost" label="Disc. Cost"></v-text-field>
              <v-text-field v-if="editInvoiceItem.totalPrice" v-model="editInvoiceItem.totalPrice" label="totalPrice"></v-text-field>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="mr-3 my-2">
              <v-spacer></v-spacer>
              <v-btn depressed outlined color="primary" @click="invoiceItemsDialogVisibility = false">Cancel</v-btn>
              <v-btn depressed color="primary" @click="handleUpdate">Update</v-btn>
          </v-card-actions>
        </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { state, getters } from '@/store/store'; 
export default {
    props: {
        headers: {
          type: Array,
          required: true
        }
    },
    data: () => ({
        invoiceItemsDialogVisibility: false,
        editInvoiceItem: {},
        height: 500
    }),
    mounted(){
      this.onWindowResize()
    },
    computed: {
      ...getters, //getParseResults
      uploadResultItems(){
        return this.getParseResults.invoiceItem.map(item => {
          let itemCost = parseInt(item.itemCost) ? item.itemCost : 0;
          let discountedPrice = parseInt(item.discountedPrice) ? item.discountedPrice : 0;
          let discountedPercentage = parseInt(item.discountedPercentage) ? item.discountedPercentage : 0;
          let totalDiscountedPrice = parseInt(item.totalDiscountedPrice) ? item.totalDiscountedPrice : 0;
          let totalPrice = parseInt(item.totalPrice) ? item.totalPrice : 0;

          return {
            ...item,
            itemCost,
            discountedPrice,
            discountedPercentage,
            totalDiscountedPrice,
            totalPrice
          }
        })
      }
    },
    methods: {
      onWindowResize(){
        this.height = window.innerHeight - 360
      },
      showEditDialog(item){
        this.editInvoiceItem = item
        this.invoiceItemsDialogVisibility = true
      },
      handleUpdate(){
        let invoiceItem = state.parsedResults.invoiceItem 
        let index = this.$_.findIndex(invoiceItem, { id: this.editInvoiceItem.id });

        state.parsedResults.invoiceItem.splice(index, 1, this.editInvoiceItem)
        this.invoiceItemsDialogVisibility = false
      }
    }
}
</script>